import { ContextProfileUser } from "../../lib/profileContext";
import { useContext, useState } from "react";
import { validateName, simplyClick } from "../../helpers";
import ButtonGroup from "../ButtonGroup";
import InputGlobal from "../InputGlobal";

import "./Name.scss";
import { errorEventsName } from "../../constants";
import Tooltip from "../Tooltip";

const Name = ({ setStep, step }) => {
  const { data, setData } = useContext(ContextProfileUser);
  const [errorName, setErrorName] = useState(null);
  const [selectedOption, setSelectedOption] = useState(null);
  const [showTooltip, setShowTooltip] = useState(false);

  const handleOptionChange = (e) => {
    const val = e.target.value;
    setSelectedOption(val);

    if (val === "option1") {
      simplyClick("cl_lnd_am30_our_members_yes");
    } else if (val === "option2") {
      simplyClick("cl_lnd_am30_our_members_skip");
    }
  };

  const handlerSubmit = () => {
    const { status, error = { text: "", type: "" } } = validateName(
      data?.first_name ?? ""
    );

    if (error.type) {
      simplyClick(errorEventsName[error.type]);
    }

    if (status) {
      simplyClick("cl_lnd_am30_want_member_next");

      setStep(step + 1);
    } else {
      setErrorName(error.text);
    }
  };

  const handleChangeName = ({ target: { value } }) => {
    setErrorName(null);
    setShowTooltip(false);
    setData({ ...data, first_name: value });
  };

  const handlerStepBack = () => {
    simplyClick("cl_lnd_am30_want_member_back");
    setStep(step - 1);
  };
  const handleFocusName = () => {
    simplyClick("cl_lnd_am30_want_member_type_name");
    setShowTooltip(true);
  };

  return (
    <div className="global__form-wrap">
      <div className="name__form">
        <span className="line" />
        <h5 className="form__title">
          We help lonely people from all over the world build connections.
        </h5>
        <p className="name__text">
          If you’re ready to join the fun, set a username
        </p>
        <div className="name__input">
          <div className="has-float-label">
            <InputGlobal
              className={"input__global" + (errorName ? " error" : "")}
              onChange={(e) => handleChangeName(e)}
              name={"name"}
              placeholder={"Enter your username"}
              type={"text"}
              id={"name__30"}
              value={data.first_name ? data.first_name : ""}
              autoComplete={"name"}
              onFocus={() => {
                if (!data.first_name) {
                  setShowTooltip(true);
                }
                simplyClick("cl_lnd_am30_want_member_type_name");
              }}
              onBlur={() => setShowTooltip(false)}
            />
            <label htmlFor="name__30" className={errorName ? "error" : ""}>
              Enter your username
            </label>
            {errorName && <p className="error-text">{errorName}</p>}
          </div>
          <p className="name__text">You can change it anytime</p>
          <Tooltip
            text="Your name must include at least 2 English letters. No numbers or special characters are allowed."
            showTooltip={showTooltip}
          />
        </div>
      </div>
      <ButtonGroup cbStepNext={handlerSubmit} cbStepBack={handlerStepBack} />
    </div>
  );
};

export default Name;
